import { cloneDeep } from 'lodash';

const state = {
  list: [],
  order: {},
  queue: {},
  completed: [],
  job_validation: {},
  selected_jobs: []
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  order: (state) => {
    return state.order || {};
  },
  queue: (state) => {
    return state.queue || {};
  },
  completed: (state) => {
    return state.completed || [];
  },
  job_validation: (state) => {
    return state.job_validation || {};
  },
  selected_jobs: (state) => {
    return state.selected_jobs || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_ORDER(state, item) {
    state.order = cloneDeep(item);
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, Object.assign(state.list[index], cloneDeep(item)));
    } else {
      state.list.push(cloneDeep(item));
    }
  },
  SET_QUEUE(state, item) {
    state.queue = item;
  },
  SET_COMPLETED(state, item) {
    state.completed = item.printJobs.concat(item.promoJobs);
  },
  SET_JOB_VALIDATION(state, item) {
    state.job_validation = item;
  },
  SET_SELECTED_JOBS(state, list) {
    state.selected_jobs = list;
  }
};

const actions = {
  getQueue({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('orders/getQueue')
        .then((response) => {
          commit('SET_QUEUE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCompleted({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('orders/getCompleted')
        .then((response) => {
          commit('SET_COMPLETED', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/getOrder?orderId=${id}`)
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  submitJobs({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('orders/submitJobs', req)
        .then((response) => {
          if (req.sandboxMode) {
            resolve(response.data);
          } else {
            commit('SET_QUEUE', response.data);
            commit('SET_SELECTED_JOBS', []);
            resolve();
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  syncProjectToJob({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/syncProjectToJob', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  syncJobToProject({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/syncJobToProject', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getPrintablePages({}, projectId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/getPrintablePages?projectId=${projectId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  savePrintablePages({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/savePrintablePages', req.pages, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveQuantity({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/saveQuantity', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeCoreProduct({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/changeCoreProduct', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveTurnaroundType({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/saveTurnaroundType', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  prepareReprint({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/prepareReprint', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateJobStatus({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/updateJobStatus', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addExternalJob({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/addExternalJob', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addTracking({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/addTracking', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateShippingAddress({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/updateShippingAddress', req.address, {
          params: { orderId: req.orderId }
        })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveOption({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/saveOption', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  validateShippingAndAddress({ commit }, jobId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/validateShippingAndAddress?jobId=${jobId}`)
        .then((response) => {
          commit('SET_JOB_VALIDATION', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  validateAddress({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/validateAddress', req.address, {
          params: { orderId: req.orderId, jobId: req.jobId }
        })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  bypassAddressValidation({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/bypassAddressValidation', {}, { params: req })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  validateDelivery({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('orders/validateDelivery', req.delivery, {
          params: { orderId: req.orderId, jobId: req.jobId }
        })
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  lookup({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/lookup?orderOrJobId=${id}`)
        .then((response) => {
          resolve(response.data.orderId);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setSelectedJobs({ commit }, list) {
    commit('SET_SELECTED_JOBS', list);
  },
  purchaseAddresses({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/purchaseAddresses?orderId=${req.orderId}&jobId=${req.jobId}`)
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addExternalRoutes({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`orders/addExternalRoutes?orderId=${req.orderId}&jobId=${req.jobId}`)
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  validateAddresses({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(
          `orders/validateAddresses?orderId=${req.orderId}&jobId=${req.jobId}&validationType=${req.validationType}`
        )
        .then((response) => {
          commit('SET_ORDER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
